package pl.mothdigital.neuronowi.theme.text

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.silk.style.extendedBy

val NoWrapTextStyle = TextBaseStyle.extendedBy {
    base { Modifier.whiteSpace(WhiteSpace.NoWrap).overflow(Overflow.Auto) }
}
